module.exports = "/src/views/player/help/images/gun2.png";